import React from 'react';
import {Routes, Route, BrowserRouter} from 'react-router-dom';

import './App.css';
import './styles/font.css'

import Home from "./pages/Home";
import AboutMe from "./pages/AboutMe";
import BlogPage from "./pages/BlogPage";
import Post from "./pages/Post";
import ContactMe from "./pages/ContactMe";

function App() {
  return <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path='/' element={< Home />}/>
            <Route path='/about' element={< AboutMe />}/>
            <Route path='/blog' element={< BlogPage />}/>
            <Route path='/post' element={< Post />}/>
            <Route path='/contact' element={< ContactMe />}/>
          </Routes>
        </BrowserRouter>
      </div>
}

export default App;
